import { jsx, jsxs } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { IconCheckOutline, IconEllipseSolid, IconEllipseOutline } from '@circlefin/euclid-icons/common';
import classNames from 'classnames';
import { VerticalStepperChildStep } from '../VerticalStepper.ChildStep/VerticalStepper.ChildStep.es.js';
import { useVerticalStepperContext } from '../VerticalStepper.Context/VerticalStepper.Context.es.js';
import { VerticalStepperStepWrapper } from '../VerticalStepper.StepWrapper/VerticalStepper.StepWrapper.es.js';

const VerticalStepperStep = ({ className, children = [], label, isStepComplete = false, isActive, stepIndex = 0, isHidden = false, ...rest })=>{
    const { isFlowComplete = false } = useVerticalStepperContext();
    // convert children to array
    const subSteps = Array.isArray(children) ? children : [
        children
    ];
    const showSubSteps = !rest.isDisabled && isActive && subSteps.length > 0;
    const isComplete = isFlowComplete || isStepComplete;
    const IconComponent = useCallback((props)=>{
        if (isComplete) {
            return jsx(IconCheckOutline, {
                ...props
            });
        }
        if (isActive) {
            return jsx(IconEllipseSolid, {
                ...props
            });
        }
        return jsx(IconEllipseOutline, {
            ...props
        });
    }, [
        isActive,
        isComplete
    ]);
    return isHidden ? null : jsxs("li", {
        className: classNames('cb-vertical-stepper-step', className),
        children: [
            jsx("div", {
                className: classNames('wrapper'),
                "data-testid": `${stepIndex + 1}-step`,
                children: jsxs(VerticalStepperStepWrapper, {
                    ...rest,
                    children: [
                        jsx(IconComponent, {
                            className: classNames('step-icon', {
                                active: isActive,
                                inactive: !isActive
                            }),
                            size: 20
                        }),
                        jsx("span", {
                            className: classNames('step-label', {
                                active: isActive,
                                inactive: !isActive
                            }),
                            children: label
                        })
                    ]
                })
            }),
            showSubSteps && jsx("ol", {
                className: classNames('substeps'),
                "data-testid": `${stepIndex + 1}-substeps`,
                children: subSteps
            })
        ]
    });
};
VerticalStepperStep.displayName = 'VerticalStepper.Step';
VerticalStepperStep.Child = VerticalStepperChildStep;

export { VerticalStepperStep };
//# sourceMappingURL=VerticalStepper.Step.es.js.map
